import { useState } from 'react';
import {
  IonIcon,
  IonText,
  IonProgressBar,
  IonButton,
  IonImg
} from '@ionic/react';
import {
  informationCircleOutline,
  chevronForwardOutline,
  chevronDownOutline
} from 'ionicons/icons';
import { getUrlFromPath } from 'libs/helpers/helper.lib';
import CustomModal from 'components/CustomModal';

import classes from './style.module.scss';

const WorkoutInfoContainer = ({
  workoutAssignment,
  progress,
  summary,
  showSummary,
  handleSummaryViewChange
}) => {
  const [popoverState, setShowPopover] = useState(false);
  return (
    <div className={classes.workoutInfoContainer}>
      <IonImg
        className={classes.image}
        src={getUrlFromPath(workoutAssignment.workout.cover)}
        alt={workoutAssignment.workout.name}
      />
      {workoutAssignment.workout.type === 'CORRECTIVE' && (
        <div className={classes.workoutInfoType}>
          <IonText className='big'>
            {workoutAssignment.workout.type.toLowerCase()}
          </IonText>
        </div>
      )}
      <div className={classes.workoutInfo}>
        <div className={classes.workoutInfoDecIcon}>
          <IonIcon
            icon={informationCircleOutline}
            size='large'
            onClick={(e) => {
              e.stopPropagation();
              setShowPopover(true);
            }}
          />
          <CustomModal
            isOpen={popoverState}
            dismiss={() => setShowPopover(false)}
            title='Notes'
            content={workoutAssignment.notes}
          />
        </div>
        <div className={classes.workoutExerciseStatus}>
          <IonProgressBar value={progress} color='secondary'></IonProgressBar>
        </div>
        <div className={classes.workoutMetaInfo}>
          <div className={classes.workoutMetaInfoCategoryName}>
            <IonText className={classes.workoutMetaInfoCategory}>
              {workoutAssignment.workoutAssignmentCategory.name}
            </IonText>
            <IonText className={classes.workoutMetaInfoName}>
              {workoutAssignment.workout.name}
            </IonText>
          </div>
          {summary && (
            <div className={classes.workoutMetaInfoShowExercises}>
              <IonButton
                fill='clear'
                onClick={(e) => {
                  e.stopPropagation();
                  handleSummaryViewChange((prevVal) => !prevVal);
                }}
              >
                <IonIcon
                  slot='icon-only'
                  icon={
                    showSummary ? chevronDownOutline : chevronForwardOutline
                  }
                ></IonIcon>
              </IonButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorkoutInfoContainer;
